import { render } from "./SVGArrowTooltipUp.vue?vue&type=template&id=33ace6b4"
import script from "./SVGArrowTooltipUp.vue?vue&type=script&lang=js"
export * from "./SVGArrowTooltipUp.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__